export default {};
throw new Error(`Could not resolve "@emotion/is-prop-valid" imported by "framer-motion".`)